import React, { useEffect } from 'react'
import draftToHtml from 'draftjs-to-html'
import type { RawDraftContentState } from 'draft-js'
import './RichTextFeatured.scss'
import { useErrorComponentEvent } from 'src/sdk/analytics/hooks/useErrorComponentEvent'
import { DEFAULT_DATA_RICH_TEXT_FEATURED } from 'src/mocks/CMSDataDefault'
import errorFunction from 'src/utils/error/errorFunction'

interface Props {
  id?: string
  fontfamily: string
  background?: string
  textcolor?: string
  content: string
  textAlign?: 'left' | 'center' | 'right'
  fontSize?: number
  linkcolor?: string
  linktarget?: string
}

const RichTextFeatured = (props: Props) => {
  const DATA = {
    id: props?.id,
    background: props?.background ?? '#FFF',
    textcolor: props?.textcolor ?? '#000',
    content: props?.content ?? DEFAULT_DATA_RICH_TEXT_FEATURED,
    fontfamily: props?.fontfamily ?? '1',
    textAlign: props?.textAlign ?? 'center',
    fontSize: props?.fontSize ?? 20,
    linkcolor: props?.linkcolor ?? '#f08769',
    linktarget: props?.linktarget ?? '_self',
  }

  const {
    id,
    background,
    textcolor,
    content,
    fontfamily,
    textAlign,
    fontSize,
    linkcolor,
    linktarget,
  } = DATA

  const customLinkTransform = (entity: any, text: string) => {
    if (entity.type === 'LINK') {
      const { url } = entity.data

      return `<a style="color: ${linkcolor}" href="${url}" target="${linktarget}">${text}</a>`
    }

    return text
  }

  const parsedContent = JSON.parse(content) as RawDraftContentState
  const result = draftToHtml(
    parsedContent,
    undefined,
    undefined,
    customLinkTransform
  )

  const { sendErrorComponentEvent } = useErrorComponentEvent('RichTextFeatured')

  useEffect(() => {
    if (!props || !props.content) {
      errorFunction(props, 'RichTextFeatured', sendErrorComponentEvent)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!props || !props.content) {
    return <></>
  }

  return (
    <div
      style={{
        color: textcolor,
        backgroundColor: background,
        textAlign,
        fontSize: `${fontSize}px`,
      }}
      id={id}
      className={`rich-text-featured-component ${
        fontfamily === '2'
          ? 'rich-text-featured-component__roboto'
          : 'rich-text-featured-component__garamond'
      }`}
      dangerouslySetInnerHTML={{ __html: result }}
    />
  )
}

export default RichTextFeatured
